var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
        _c("div", { staticClass: "panel-tag" }, [
          _vm._v(
            "\n\t\t\t\t" + _vm._s(_vm.__t("CATEG_TAG_PRODUCTS")) + "\n\t\t\t"
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "catge_products_block" },
          [
            _c("b-table", {
              staticClass: "table-responsive-xl resolution_table",
              attrs: {
                "head-variant": "dark",
                "thead-class": _vm.head_class,
                "tbody-tr-class": _vm.rowClass,
                striped: "",
                items: _vm.cat_prods,
                fields: _vm.fields,
              },
              scopedSlots: _vm._u([
                {
                  key: "cell(qty)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "form-group mt-2",
                          staticStyle: { "max-width": "200px" },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "form-label",
                              attrs: { for: "advanced_price" },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.__t("PROD_QUAL_CATEG")) +
                                  "\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "input-group flex-nowrap" },
                            [
                              _c(
                                "div",
                                { staticClass: "input-group-prepend" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "input-group-text" },
                                    [
                                      _c("i", {
                                        staticClass: "fal fa-typewriter fs-xl",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: data.item.qty,
                                    expression: "data.item.qty",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { id: "advanced_price", type: "text" },
                                domProps: { value: data.item.qty },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      data.item,
                                      "qty",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(product)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "form-group mt-2",
                          staticStyle: { "min-width": "350px" },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "form-label",
                              attrs: { for: "advanced_price" },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.__t("PRODUCT")) +
                                  "\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "input-group flex-nowrap" },
                            [
                              _c("v-select", {
                                staticClass: "imc_reason form-controls",
                                attrs: {
                                  label: "title",
                                  searchable: true,
                                  filterable: true,
                                  options: _vm.products,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (option) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "d-center" },
                                            [
                                              _c("div", [
                                                _vm._v(_vm._s(option.title)),
                                              ]),
                                              _vm._v(" "),
                                              _c("div", [
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "small badge border border-info text-info mr-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                        Uniq ID :" +
                                                          _vm._s(
                                                            option.uniq_id
                                                          ) +
                                                          "\n                                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _c("small", [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tID :" +
                                                        _vm._s(option.id) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: data.item.product,
                                  callback: function ($$v) {
                                    _vm.$set(data.item, "product", $$v)
                                  },
                                  expression: "data.item.product",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(id)",
                  fn: function (data) {
                    return [
                      _c("i", {
                        staticClass: "fal fa-trash cursor-pointer",
                        on: {
                          click: function ($event) {
                            return _vm.remove(data.index)
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "add_button mt-2" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-lg btn-outline-primary waves-effect waves-themed",
              attrs: { type: "button" },
              on: { click: _vm.push_empty },
            },
            [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.__t("ADD")) + "\n\t\t\t\t")]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }